import { CloseRounded } from '@mui/icons-material'
import { Backdrop, Typography } from '@mui/material'
import { grey } from '@mui/material/colors'
import { styled } from '@mui/system'
import { AnimatePresence, motion } from 'framer-motion'
import { ReactNode } from 'react'



const Header = styled(motion.div)(({theme})=>({


    width: "100%",
    backgroundColor: theme.palette.primary.main,
    border: `.5px solid rgba(255, 255, 255, 0.1)`,
    borderRadius: theme.shape.borderRadius,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    padding: theme.spacing(2),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    zIndex: 20

}))

const Body = styled(motion.div)(({theme})=>({

    width: "100%",
    backgroundColor: theme.palette.primary.main,
    border: `.5px solid rgba(255, 255, 255, 0.1)`,
    borderRadius: theme.shape.borderRadius,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    padding: theme.spacing(2),
    zIndex: 20

}))

const CustomBackdrop = styled(Backdrop)(({theme})=>({
    top: "-5%",
    left: 0,
    zIndex: 100,
    height: "105%",
    margin: 0,
    backgroundColor: "rgba(255, 255, 255, 0.0)",
    flexDirection: "column",
}))

const modalVariants = {
    initial: {
        y: -220
    },
    final: {
        y: 0
    }
}


interface iModalProps{
    children: ReactNode
    subtitle: string
    title: string
    visible: boolean
    width?: string
    setVisibility: (prop:boolean)=>void
}

export default function Modal({children, subtitle, title, visible=false, width="40%",setVisibility}:iModalProps) {

    return (
        <>
            <CustomBackdrop
                open={visible}
                // @ts-ignore
                component={motion.div}
                animate={{
                    backgroundColor: "rgba(255, 255, 255, 0.4)",
                    transition:{
                        when: "beforeChildren",
                        staggerChildren: 0.3,
                        delay:0.5
                    }
                }}
                key="backdrop"
            >
                {/* @ts-ignore */}
                <AnimatePresence>
                    {
                        
                        visible && (
                            <motion.div
                                exit={{y: -500, transition:{duration: 1}}}
                                style={{
                                    width: "40%"
                                }}
                                key="modal"
                                variants={modalVariants}
                                initial="initial"
                                animate="final"
                            >
                                <Header
                                >
                                    <div>
                                        <Typography variant="h6" sx={{color: "grey.200"}}>
                                            {title}
                                        </Typography>
                                        <Typography variant="subtitle2" color="grey.500" fontWeight={400} >
                                            {subtitle}
                                        </Typography>
                                    </div>

                                    <CloseRounded 
                                        fontSize='small' 
                                        htmlColor={grey[200]} 
                                        onClick={()=>setVisibility(false)}
                                    />

                                </Header>
                                <Body
                                    onClick={()=>{}}                          
                                >
                                    <motion.div>
                                        {children}
                                    </motion.div>
                                </Body>
                        
                            </motion.div>
                        )
                    }
                </AnimatePresence>

            </CustomBackdrop>
        </>
    )
}
